export default "__VITE_ASSET__OMNNZjup__"